import moment from 'moment';
import { Control, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { Colors } from '../../themes';
import { DatePickerSelector } from '../forms';

type QuickReminderFieldProps = {
  control: Control<any>;
  setValue: UseFormSetValue<any>;
};

export const QuickReminderField = ({
  control,
  setValue,
}: QuickReminderFieldProps) => {
  const { t } = useTranslation();

  return (
    <>
      <View>
        <Text style={styles.formItemTitle}>
          {t('issue.quickReminder.header')}
        </Text>
      </View>
      <Text style={styles.subheader}>{t('issue.quickReminder.subheader')}</Text>
      <DatePickerSelector
        name="quickReminderDate"
        setValue={setValue}
        control={control}
        label=""
        placeholder={t('issue.dateFormat')}
        containerStyle={styles.datePickerContainer}
        calendarIconStyle={styles.calendarIconStyle}
        maxYears={5}
        minDate={moment().add(1, 'day').format('YYYY-MM-DD')}
      />
    </>
  );
};

const styles = StyleSheet.create({
  formItemTitle: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 16,
    marginBottom: 16,
  },
  subheader: {
    color: Colors.grayText,
    fontSize: 14,
    fontWeight: '400',
    letterSpacing: -0.2,
    marginBottom: 16,
  },
  datePickerContainer: {
    borderWidth: 1,
    borderColor: Colors.grayText,
    height: 52,
    flex: 1,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    marginTop: 8,
    ...(Platform.OS === 'web' && {
      maxHeight: 52,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      height: 52,
      minHeight: 52,
      overflow: 'visible',
      paddingVertical: 0,
      position: 'relative',
    }),
  },
  calendarIconStyle: {
    ...(Platform.OS === 'web' && {
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
  },
});
